import moment from 'moment';

function dateToMonth(date) {
  var check = moment(date, 'MM-YYYY');
  return check.format('MMM');
}

export function dateToMonthYear(date) {
  var check = moment(date, 'MM-YYYY');
  return check.format('MMM YY');
}

export default dateToMonth;
